export const translations = {
  es: {
    nav: {
      story: "Historia",
      details: "Detalles",
      travel: "Información de Viaje",
      itinerary: "Programa",
      venue: "Lugar",
      gallery: "Galería",
      rsvp: "Confirmar",
    },
    hero: {
      saveTheDate: "Guarda la Fecha",
      and: "&",
      date: "28 de Noviembre, 2026",
      location: "Guadalajara, Jalisco · México",
      cta: "Confirmar Asistencia",
      countdown: {
        days: "Días",
        hours: "Horas",
        minutes: "Minutos",
        seconds: "Segundos",
      },
    },
    story: {
      eyebrow: "Nuestra Historia",
      title: "Cuando el amor llama a la puerta...",
      body: [
        "Edouard, un ingeniero espacial acostumbrado a enviar satélites al universo, jamás imaginó que ella se convertiría en su universo entero.",
        "Alejandra, gerente de Recursos Humanos, jamás imaginó que él se convertiría en su persona favorita.",
        "Todo comenzó en un hermoso día de verano irlandés. Alejandra disfrutaba de los últimos rayos de sol en el balcón con su amiga Kae, sin esperar vivir la \"Diosidencia\" más perfecta.",
        "De repente, Edouard apareció en el parque, como un Romeo que viene a conquistar a su \"Dulcinea\". Kae no tardó en orquestar el encuentro perfecto, y como en las películas, Edouard llegó y llamó a la puerta de Alejandra. Ella no pudo evitar pensar en su mamá, quien alguna vez le dijo: \"Tienes que salir, el amor no va a venir a tocar a tu puerta\".",
        "Tras unos años compartiendo fe, amor y risas, momentos inolvidables entre tacos mexicanos, cervezas belgas y pubs irlandeses, Edouard empezó a tramar algo que Alejandra jamás imaginó. Le preparó una sorpresa de cumpleaños muy especial. Convencida de que viajaría a Bélgica el fin de semana, ¡jamás se imaginó que estaría soplando las velas en Roma! ¡Menuda sorpresa se llevó en el aeropuerto! Pero Edouard tenía reservada una sorpresa aún mayor.",
        "Fue un domingo por la mañana en el Vaticano, después de escuchar la misa en la Basílica de San Pedro, cuando Edouard, estando en la Plaza de San Pedro bañada por esa luz solar mística cuyo secreto sólo la Dolce Vita italiana guarda, ¡se arrodilló e hizo la pregunta que nos reúne a todos hoy!",
      ],
      signature: "Alejandra & Edouard",
    },
    welcome: {
      eyebrow: "Bienvenidos",
      title: "Bienvenidos a nuestra boda",
      body: [
        "¡Está sucediendo! Estamos absolutamente felices de celebrar nuestro gran día con todas las personas que más queremos.",
        "Aquí encontrarás todo lo que necesitas saber sobre la boda: información de viaje, hospedaje, itinerario y detalles para confirmar tu asistencia.",
        "Gracias por ser parte de nuestra historia. No podemos esperar a celebrar juntos en Guadalajara, Jalisco, México.",
      ],
      signature: "Con amor,\nAlejandra & Edouard",
    },
    itinerary: {
      eyebrow: "El Día",
      title: "Programa",
      events: [
        { time: "15:30 hrs", title: "Santa Misa", place: "Hacienda Benazuza · Capilla" },
        { time: "17:00 hrs", title: "Cóctel de Bienvenida", place: "Hacienda Benazuza · Jardín" },
        { time: "18:00 hrs", title: "Cena & Recepción", place: "Hacienda Benazuza · Salón Principal" },
        { time: "00:00 hrs", title: "Fin de Fiesta", place: "Hacienda Benazuza" },
      ],
      unplugged: {
        label: "📵 Ceremonia sin celulares",
        body: "Durante la Misa, les pedimos amablemente guardar sus celulares y cámaras para estar completamente presentes con nosotros mientras decimos \u201Csí, acepto\u201D. 🤍",
        photographers: "Dejen que nuestros fotógrafos capturen estos momentos tan especiales mientras ustedes simplemente los disfrutan con nosotros.",
        after: "Una vez terminada la Misa, ¡las cámaras son todas suyas! Tomen todas las fotos y videos que quieran. 📸✨",
      },
    },
    venue: {
      eyebrow: "El Lugar",
      title: "Hacienda Benazuza",
      address:
        "Carretera a Colotlán Km 5.3, Ejido Copalita, 45200 Zapopan, Jalisco, México",
      cta: "Ver en Google Maps",
      parkingLabel: "Valet Parking",
      parkingNote: "Contamos con servicio de valet parking para quienes lleguen en auto. Sin embargo, nuestra recomendación es trasladarse en Uber. Por favor, no manejes si tomaste. ¡Cuídate!",
    },
    details: {
      eyebrow: "Detalles",
      title: "Lo que debes saber",
      dressCode: {
        title: "Código de Vestimenta",
        value: "Riguroso Formal",
        note: "Hombres: Traje formal oscuro, camisa y corbata.\nMujeres: Vestido largo.",
        avoid: "Por favor evita estos colores:",
        avoidPalette: [
          { name: "Blanco", hex: "#FFFFFF" },
          { name: "Beige", hex: "#E8DCC4" },
          { name: "Rojo", hex: "#D11A2A" },
        ],
      },
      registry: {
        title: "Mesa de Regalos",
        value: "Transferencia Bancaria",
        note: "Los detalles para el obsequio están disponibles en tu invitación personalizada. Por favor, accede con tu enlace único de RSVP para verlos.",
        privateNote: "Su presencia en nuestra boda es el mejor regalo que podríamos recibir. Si desean hacernos un obsequio, les agradeceremos mucho una contribución mediante transferencia bancaria para ayudarnos a comenzar esta nueva etapa juntos. ¡Gracias por su cariño y generosidad!",
        privateHeading: "Nuestros Datos Bancarios",
        mxFlag: "🇲🇽",
        mxTitle: "Para invitados en México",
        mxRows: [
          { label: "Banco", value: "Bx+" },
          { label: "Titular", value: "Janette Alejandra Alvarez Gonzalez" },
          { label: "CLABE", value: "113 1800 0000 6613 172" },
          { label: "Moneda", value: "MXN ($)" },
        ],
        euFlag: "🇪🇺",
        euTitle: "Para invitados en Europa",
        euRows: [
          { label: "Cuenta EUR", value: "Wise" },
          { label: "Nombre", value: "Janette Alejandra Alvarez Gonzalez" },
          { label: "IBAN", value: "BE73 9674 1906 8860" },
          { label: "SWIFT/BIC", value: "TRWIBEB1XXX" },
          { label: "Moneda", value: "EUR (€)" },
          { label: "Dirección", value: "Wise, Rue du Trône 100, 3rd floor, Brussels, 1050, Belgium" },
        ],
      },
      adultsOnly: {
        title: "Celebración Solo para Adultos",
        body: "Aunque adoramos a los más pequeños, hemos decidido que nuestra boda sea una celebración exclusivamente para adultos. Esperamos que esta sea una oportunidad para que puedan relajarse, disfrutar de la celebración y compartir esta noche tan especial con nosotros.",
        thanks: "¡Gracias por su comprensión!",
      },
      hotel: {
        title: "Hospedaje",
        value: "Hoteles recomendados",
        note: "Estos hoteles están ubicados en zonas convenientes con fácil acceso a restaurantes, comercios y transporte.",
      },
    },
    gallery: {
      eyebrow: "Galería",
      title: "Nosotros",
    },
    rsvp: {
      eyebrow: "RSVP",
      title: "Confirma tu asistencia",
      subtitle: "Por favor confirma antes del 12 de octubre, 2026.",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      mobilePhone: "Teléfono móvil (con lada)",
      mobilePhonePlaceholder: "Ej. +52 33 1234 5678",
      attending: "¿Asistirás?",
      yes: "Sí, ahí estaré",
      no: "Lamentablemente no podré",
      guestsCount: "Número de invitados (incluyéndote)",
      dietary: "Alergias alimentarias",
      dietaryPlaceholder: "",
      message: "Mensaje para los novios",
      messagePlaceholder: "Déjanos unas palabras...",
      submit: "Enviar confirmación",
      submitting: "Enviando...",
      success: "¡Gracias! Tu confirmación ha sido registrada.",
      error: "Hubo un problema. Inténtalo de nuevo.",
      inviteOnly: "Por favor utiliza el link único de invitación que te enviamos para confirmar tu asistencia.",
      closingTitle: "Nuestro Para Siempre Comienza Aquí",
      closingMessage: "Gracias por ser parte de nuestra historia. Prepárate para celebrar, reír y bailar con nosotros. ¡Te esperamos!",
    },
    accommodation: {
      hotels: [
        { name: "Riu Plaza Guadalajara", note: "Hotel de lujo moderno con vistas espectaculares de la ciudad y ubicación céntrica.", url: "https://www.riu.com/en/hotel/mexico/guadalajara/hotel-riu-plaza-guadalajara/" },
        { name: "Hilton Guadalajara Midtown", note: "Confort contemporáneo en el corazón del vibrante distrito financiero y gastronómico de Guadalajara.", url: "https://www.hilton.com/en/hotels/gdlgmhh-hilton-guadalajara-midtown/" },
        { name: "Quinta Real Guadalajara", note: "Elegancia mexicana de lujo rodeada de hermosos jardines y encanto histórico.", url: "https://www.grupocaminoreal.com/quinta-real-guadalajara" },
        { name: "Fiesta Americana Guadalajara", note: "Hotel cómodo y bien ubicado que ofrece excelente valor y fácil acceso a las principales atracciones de la ciudad.", url: "https://www.fiestamericana.com/en/fiesta-americana-guadalajara" },
        { name: "Hyatt Regency Andares Guadalajara", note: "Hotel moderno de lujo dentro del exclusivo distrito Andares, con acceso directo a boutiques, restaurantes y vida nocturna.", url: "https://www.hyatt.com/hyatt-regency/es-ES/gdlrg-hyatt-regency-andares-guadalajara" },
        { name: "AC Hotel Guadalajara", note: "Diseño europeo contemporáneo y ambiente sofisticado, ideal para viajeros que buscan estilo, confort y buena ubicación.", url: "https://www.marriott.com/en-us/hotels/gdlac-ac-hotel-guadalajara-mexico/overview/" },
      ],
    },
    travel: {
      eyebrow: "Viaje",
      title: "Información para Viajeros",
      airport: {
        title: "Aeropuerto",
        body: "El aeropuerto más cercano es el Aeropuerto Internacional de Guadalajara (GDL), oficialmente conocido como Aeropuerto Internacional Miguel Hidalgo y Costilla. Se encuentra aproximadamente a 30–40 minutos de la mayoría de las zonas de Guadalajara y Zapopan, dependiendo del tráfico.",
      },
      transport: {
        title: "Transporte desde el Aeropuerto",
        items: [
          { name: "Taxi Oficial del Aeropuerto", body: "Los taxis oficiales están disponibles justo afuera de la terminal de llegadas. Opción segura, confiable y con tarifas fijas según destino. Recomendado si visitas la ciudad por primera vez o llegas tarde por la noche." },
          { name: "Uber & DiDi", body: "Uber y DiDi están ampliamente disponibles en Guadalajara y suelen ser la forma más conveniente y económica de desplazarse. Al llegar, sigue las instrucciones de recogida en la app: los puntos de encuentro pueden variar." },
        ],
      },
      currency: {
        title: "Moneda",
        body: "La moneda local es el Peso Mexicano (MXN). Las tarjetas de crédito y débito son ampliamente aceptadas en hoteles, restaurantes y comercios; sin embargo, llevar algo de efectivo puede ser útil para mercados locales, propinas y establecimientos pequeños.",
      },
      weather: {
        title: "Clima",
        body: "Finales de noviembre es una de las mejores épocas para visitar Guadalajara. Días soleados, baja humedad y temperaturas agradables entre 10°C y 28°C (50°F–82°F). Los días son cálidos, pero las mañanas y noches pueden ser frescas — trae una chaqueta ligera o suéter para eventos al aire libre después del atardecer.",
      },
      language: {
        title: "Idioma",
        body: "El español es el idioma oficial de México. El inglés se habla con frecuencia en hoteles, restaurantes y zonas turísticas, pero los locales apreciarán mucho que intentes comunicarte con algunas frases básicas en español.",
      },
      tips: {
        title: "Consejos Locales",
        items: [
          "Bebe agua embotellada o filtrada en lugar de agua del grifo.",
          "Dejar propina es costumbre en México. En restaurantes, lo habitual es 10–15% del total.",
          "Uber es nuestra opción recomendada para moverse por Guadalajara.",
          "Los enchufes son Tipo A y B (mismos que Estados Unidos y Canadá), 127V.",
          "La mayoría de tiendas y restaurantes aceptan tarjetas, pero lleva algo de efectivo para compras pequeñas.",
          "Visita nuestras zonas favoritas: Punto Sao Paulo, Andares, Providencia, Avenida Chapultepec y Tlaquepaque — excelentes restaurantes, cafeterías, tiendas y vida nocturna.",
        ],
      },
      emergency: {
        title: "Información de Emergencia",
        body: "Servicios de Emergencia: 911. Si tienes cualquier duda durante tu estancia, no dudes en contactarnos. ¡Estaremos encantados de ayudarte!",
      },
      note: {
        title: "Un Mensaje de los Novios",
        body: "Para muchos de ustedes, esta será su primera visita a México, y no podríamos estar más emocionados de compartir nuestro hogar, nuestra cultura y nuestras tradiciones. Esperamos que puedan tomarse un tiempo para explorar Guadalajara, disfrutar de su increíble gastronomía y experimentar la calidez y hospitalidad que hacen de esta ciudad un lugar tan especial. Gracias por viajar desde cerca y desde lejos para celebrar con nosotros. Su presencia significa muchísimo para nosotros y estamos deseando crear recuerdos inolvidables juntos.",
      },
    },

    footer: {
      message: "Con amor, Alejandra & Edouard",
      date: "28.NOV.2026",
      location: "GUADALAJARA, JALISCO, MÉXICO",
    },
    admin: {
      title: "Panel de Administración",
      loginTitle: "Acceso de administrador",
      password: "Contraseña",
      login: "Ingresar",
      logout: "Cerrar sesión",
      stats: {
        total: "Confirmaciones",
        attending: "Asisten",
        notAttending: "No asisten",
        totalGuests: "Total de invitados",
      },
      table: {
        name: "Nombre",
        email: "Correo",
        phone: "Teléfono",
        attending: "Asiste",
        guests: "Invitados",
        dietary: "Alergias",
        message: "Mensaje",
        date: "Fecha",
        actions: "Acciones",
        delete: "Eliminar",
        empty: "Aún no hay confirmaciones.",
      },
      invalidPassword: "Contraseña incorrecta",
      tabs: { rsvps: "Confirmaciones", guests: "Lista de Invitados" },
      guests: {
        search: "Buscar por nombre, código o correo...",
        filterAll: "Todos",
        filterPending: "Pendientes",
        filterConfirmed: "Confirmados",
        filterDeclined: "Declinaron",
        export: "Exportar CSV",
        importCsv: "Importar CSV",
        addGuest: "Agregar invitado",
        copyLink: "Copiar link",
        linkCopied: "¡Copiado!",
        sendWhatsapp: "WhatsApp",
        whatsappMessage: "Hola {name}!\n\nEs oficial… ¡nos casamos! 💍\n\nDesde los primeros recuerdos que creamos juntos hasta todos los sueños que hoy compartimos, cada momento nos ha acercado a este día. Estamos muy emocionados de dar el siguiente paso y comenzar este hermoso camino juntos.\n\nCon mucho cariño te compartimos nuestro website, donde encontrarás todos los detalles de nuestro gran día y todo lo que necesitas saber para celebrar con nosotros: https://alejandraedouard.com\n\nCuando estés lista/o, confirma tu asistencia antes del *12 de octubre* con tu link personalizado:\n{link}\n\n¡Sería un verdadero honor tenerte con nosotros creando recuerdos que se quedarán en nuestros corazones para siempre!\n\nPor favor guarda ambos links — podrás volver cuando quieras para revisar detalles o modificar tu confirmación.\n\nSi tienes alguna pregunta o necesitas ayuda con tu RSVP, no dudes en escribirnos por aquí.\n\n¡Contando los días para celebrar juntos! 🥂🤍\nAlejandra & Edouard",
        cols: {
          name: "Nombre",
          code: "Código",
          reserved: "Reservados",
          confirmed: "Confirmados",
          status: "Estado",
          email: "Correo",
          phone: "WhatsApp / Teléfono",
          dietary: "Alergias",
          responseDate: "Fecha de respuesta",
          link: "Link",
          actions: "Acciones",
        },
        status: { pending: "Pendiente", confirmed: "Confirmado", declined: "Declinó" },
        stats: { totalGuests: "Invitados", confirmed: "Confirmados", declined: "Declinaron", pending: "Pendientes", reservedSeats: "Lugares reservados", confirmedSeats: "Lugares confirmados" },
        addModal: {
          title: "Agregar invitado",
          firstName: "Nombre",
          lastName: "Apellido",
          email: "Correo",
                   phone: "WhatsApp / Teléfono (con lada)",
          phonePlaceholder: "Ej. +5213312345678",
          code: "Código de invitación",
          codeHelp: "Ej. ANA2026 (se usa en el link único)",
          seats: "Lugares reservados",
          language: "Idioma del invitado",
          notes: "Notas internas",
          save: "Guardar",
          cancel: "Cancelar",
        },
        importModal: {
          title: "Importar invitados desde CSV",
          help: "Sube un archivo CSV con columnas: first_name, last_name, email, phone, invitation_code, reserved_seats, language, notes. El código debe ser único; si lo omites lo generamos automáticamente.",
          choose: "Seleccionar archivo",
          import: "Importar",
          imported: "{n} invitados importados",
          error: "Error al importar el archivo",
          downloadTemplate: "Descargar plantilla CSV",
        },
        empty: "Aún no hay invitados. Agrega uno o importa un CSV.",
      },
    },
    guestRsvp: {
      loading: "Cargando tu invitación...",
      invalidTitle: "Link no válido",
      invalidBody: "No encontramos tu invitación. Verifica el link que te compartimos o contacta a los novios.",
      welcome: "¡Hola, {name}!",
      reservedOne: "Hemos reservado {n} lugar para ti.",
      reservedMany: "Hemos reservado {n} lugares para tu grupo.",
      questionAttend: "¿Podrás acompañarnos?",
      yes: "Sí, asistiré",
      no: "Lamentablemente no podré",
      attendingCount: "Número de personas que asistirán",
      attendeeNames: "Nombre completo de cada asistente",
      attendeeNamePlaceholder: "Nombre del asistente {n}",
      dietary: "Alergias alimentarias",
      notes: "Mensaje para los novios",
      notesPlaceholder: "Déjanos unas palabras...",
      submit: "Enviar respuesta",
      submitting: "Enviando...",
      update: "Actualizar respuesta",
      alreadyConfirmed: "Ya confirmaste tu asistencia el {date}. Puedes actualizar tu respuesta si lo necesitas.",
      alreadyDeclined: "Recibimos tu respuesta el {date}. Si cambia algo, puedes actualizarla aquí.",
      successTitle: "¡Gracias por confirmar!",
      successBody: "Gracias por confirmar tu asistencia. Estamos deseando celebrar contigo.",
      successDeclined: "Gracias por avisarnos. Te vamos a extrañar muchísimo.",
      maxSeatsHint: "Solo puedes confirmar hasta {n} personas según tu invitación.",
      backHome: "Volver al sitio",
      error: "Hubo un problema. Inténtalo de nuevo.",
      closedNotice: "El periodo de confirmación cerró el 12 de octubre de 2026.",
      closedConfirmed: "Confirmaste tu asistencia para {n} persona(s). ¡Gracias!",
      closedDeclined: "Recibimos tu respuesta: no podrás acompañarnos. ¡Gracias por avisarnos!",
      closedPending: "No recibimos tu confirmación. Si tienes alguna duda, contacta directamente a los novios.",
      expiredTitle: "¡Gracias de corazón!",
      expiredBody: "Gracias por ser parte de nuestra historia y por todo su cariño. Este link personalizado ya no está activo, pero siempre llevaremos con nosotros los recuerdos de este día tan especial.",
    },
  },
  en: {
    nav: {
      story: "Story",
      details: "Details",
      travel: "Travel Information",
      itinerary: "Timeline",
      venue: "Venue",
      gallery: "Gallery",
      rsvp: "RSVP",
    },
    hero: {
      saveTheDate: "Save the Date",
      and: "&",
      date: "November 28, 2026",
      location: "Guadalajara, Jalisco · Mexico",
      cta: "RSVP Now",
      countdown: {
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
      },
    },
    story: {
      eyebrow: "Our Story",
      title: "When love comes knocking at your door...",
      body: [
        "Edouard, a space engineer accustomed to sending satellites into the universe, never imagined that she would become his entire universe.",
        "Alejandra, a Human Resources manager, never imagined that he would become her favorite human being.",
        "It all began on a beautiful Irish summer day when Alejandra was enjoying the last rays of sunshine on the balcony with her friend Kae, not expecting to experience the most perfect \"Diosidencia\".",
        "Out of nowhere, Edouard appeared in the park below, like a Romeo coming to conquer his \"Dulcinea.\" It didn't take much more for Kae to orchestrate the perfect meeting, and just like in the movies, Edouard came and knocked on Alejandra's door. She couldn't help but think of her mother, who once told her, \"Get out there, love isn't going to come knocking on your door.\"",
        "After a few years sharing faith, love and laughs, somewhere between Mexican tacos, Belgian beers, and Irish pub nights, Edouard started cooking up something that Alejandra never saw coming. He planned a special birthday surprise. Convinced she was traveling to Belgium for the weekend, she never expected to be blowing out her candles in Rome! What a surprise it was at the airport! But he had an even bigger surprise in store.",
        "It was on a Sunday morning in the Vatican, after attending the Mass at St. Peter's Basilica, that Edouard standing in St. Peter's Square bathed in that mystical sunlight that only the Italian Dolce Vita holds the secret to, got down on one knee and asked the question that brings us all together today!",
      ],
      signature: "Alejandra & Edouard",
    },
    welcome: {
      eyebrow: "Welcome",
      title: "Welcome to our wedding",
      body: [
        "It's happening! We are absolutely over the moon to celebrate our big day with all our favorite humans from around the world.",
        "Here you'll find everything you need to know about the wedding including travel information, accommodations, schedules, and RSVP details.",
        "Thank you for being part of our story and we honestly can't wait to celebrate together in Guadalajara, Jalisco, Mexico.",
      ],
      signature: "With love,\nAlejandra & Edouard",
    },
    itinerary: {
      eyebrow: "The Day",
      title: "Timeline",
      events: [
        { time: "3:30 PM", title: "Holy Mass", place: "Hacienda Benazuza · Chapel" },
        { time: "5:00 PM", title: "Welcome Cocktail", place: "Hacienda Benazuza · Garden" },
        { time: "6:00 PM", title: "Dinner & Reception", place: "Hacienda Benazuza · Main Hall" },
        { time: "12:00 AM", title: "End of Party", place: "Hacienda Benazuza" },
      ],
      unplugged: {
        label: "📵 Unplugged Ceremony",
        body: "During the Mass, we kindly ask you to put your phones and cameras away and be fully present with us as we say \u201CI do.\u201D 🤍",
        photographers: "Let our photographers capture these precious moments while you simply enjoy them with us.",
        after: "Once the Mass is over, the cameras are yours — take all the photos and videos you'd like! 📸✨",
      },
    },
    venue: {
      eyebrow: "The Venue",
      title: "Hacienda Benazuza",
      address:
        "Carretera a Colotlán Km 5.3, Ejido Copalita, 45200 Zapopan, Jalisco, Mexico",
      cta: "Open in Google Maps",
      parkingLabel: "Valet Parking",
      parkingNote: "Valet parking service is available for guests arriving by car. However, our recommendation is to travel by Uber. Please don't drink and drive. Stay safe!",
    },
    details: {
      eyebrow: "Details",
      title: "Everything you need to know",
      dressCode: {
        title: "Dress Code",
        value: "Formal Attire",
        note: "Men: Dark formal suit, dress shirt and tie.\nWomen: Long dress.",
        avoid: "Please avoid these colors:",
        avoidPalette: [
          { name: "White", hex: "#FFFFFF" },
          { name: "Beige", hex: "#E8DCC4" },
          { name: "Red", hex: "#D11A2A" },
        ],
      },
      registry: {
        title: "Gift Registry",
        value: "Bank Transfer",
        note: "The gift details are available on your personalized invitation. Please open your unique RSVP link to view them.",
        privateNote: "Your presence at our wedding is the greatest gift we could ask for. If you would like to honor us with a gift, we kindly invite you to contribute to our future together through a bank transfer. Thank you for your generosity and for celebrating this special day with us.",
        privateHeading: "Our Bank Details",
        mxFlag: "🇲🇽",
        mxTitle: "For guests in Mexico",
        mxRows: [
          { label: "Bank", value: "Bx+" },
          { label: "Account Holder", value: "Janette Alejandra Alvarez Gonzalez" },
          { label: "CLABE", value: "113 1800 0000 6613 172" },
          { label: "Currency", value: "MXN ($)" },
        ],
        euFlag: "🇪🇺",
        euTitle: "For guests in Europe",
        euRows: [
          { label: "EUR Account", value: "Wise" },
          { label: "Name", value: "Janette Alejandra Alvarez Gonzalez" },
          { label: "IBAN", value: "BE73 9674 1906 8860" },
          { label: "SWIFT/BIC", value: "TRWIBEB1XXX" },
          { label: "Currency", value: "EUR (€)" },
          { label: "Address", value: "Wise, Rue du Trône 100, 3rd floor, Brussels, 1050, Belgium" },
        ],
      },
      adultsOnly: {
        title: "Adults-Only Celebration",
        body: "While we absolutely adore your little ones, we have chosen to make our wedding an adults-only celebration. We hope this gives you the opportunity to relax, celebrate, and enjoy the evening with us.",
        thanks: "Thank you for your understanding!",
      },
      hotel: {
        title: "Accommodation",
        value: "Recommended hotels",
        note: "These hotels are located in convenient areas with easy access to restaurants, shopping, and transportation.",
      },
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Our Moments",
    },
    rsvp: {
      eyebrow: "RSVP",
      title: "Confirm your attendance",
      subtitle: "Please reply before October 12, 2026.",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      mobilePhone: "Mobile phone (with country code)",
      mobilePhonePlaceholder: "e.g. +52 33 1234 5678",
      attending: "Will you attend?",
      yes: "Yes, I'll be there",
      no: "Sadly, I can't make it",
      guestsCount: "Number of guests (including you)",
      dietary: "Food allergies",
      dietaryPlaceholder: "",
      message: "Message to the couple",
      messagePlaceholder: "Leave us a few words...",
      submit: "Send RSVP",
      submitting: "Sending...",
      success: "Thank you! Your RSVP has been received.",
      error: "Something went wrong. Please try again.",
      inviteOnly: "Please use the unique invitation link we sent you to confirm your attendance.",
      closingTitle: "Our Forever Begins Here",
      closingMessage: "Thank you for being part of our story. Get ready to celebrate, laugh and dance with us. We can't wait to see you!",
    },
    accommodation: {
      hotels: [
        { name: "Riu Plaza Guadalajara", note: "Modern luxury hotel with stunning city views and a central location.", url: "https://www.riu.com/en/hotel/mexico/guadalajara/hotel-riu-plaza-guadalajara/" },
        { name: "Hilton Guadalajara Midtown", note: "Contemporary comfort in the heart of Guadalajara's vibrant financial and dining district.", url: "https://www.hilton.com/en/hotels/gdlgmhh-hilton-guadalajara-midtown/" },
        { name: "Quinta Real Guadalajara", note: "Elegant Mexican-style luxury surrounded by beautiful gardens and historic charm.", url: "https://www.grupocaminoreal.com/quinta-real-guadalajara" },
        { name: "Fiesta Americana Guadalajara", note: "Comfortable and well-located hotel offering excellent value and easy access to the city's main attractions.", url: "https://www.fiestamericana.com/en/fiesta-americana-guadalajara" },
        { name: "Hyatt Regency Andares Guadalajara", note: "Sleek modern luxury inside the upscale Andares district, with direct access to boutiques, dining and nightlife.", url: "https://www.hyatt.com/hyatt-regency/gdlrg-hyatt-regency-andares-guadalajara" },
        { name: "AC Hotel Guadalajara", note: "Contemporary European design and a refined atmosphere — ideal for travelers who value style, comfort and a great location.", url: "https://www.marriott.com/en-us/hotels/gdlac-ac-hotel-guadalajara-mexico/overview/" },
      ],
    },
    travel: {
      eyebrow: "Travel",
      title: "Travel Information",
      airport: {
        title: "Airport",
        body: "The nearest airport is Guadalajara International Airport (GDL), officially known as Miguel Hidalgo y Costilla International Airport. It is located approximately 30–40 minutes from most areas of Guadalajara and Zapopan, depending on traffic.",
      },
      transport: {
        title: "Transportation from the Airport",
        items: [
          { name: "Official Airport Taxi", body: "Official airport taxis are available directly outside the arrivals terminal. Safe, reliable, with fixed rates by destination. Recommended for first-time visitors or those arriving late at night." },
          { name: "Uber & Ride-Sharing Apps", body: "Uber and DiDi are widely available in Guadalajara and are often the most convenient and affordable way to get around. Follow the pick-up instructions in the app — designated meeting points may vary." },
        ],
      },
      currency: {
        title: "Currency",
        body: "The local currency is the Mexican Peso (MXN). Credit and debit cards are widely accepted in hotels, restaurants and most shops; carrying a small amount of cash can be useful for local markets, tips and smaller businesses.",
      },
      weather: {
        title: "Weather",
        body: "Late November is one of the most beautiful times to visit Guadalajara. Expect sunny days, low humidity, and pleasant temperatures typically from 50°F to 82°F (10°C–28°C). Days are warm, but mornings and evenings can be fresh — bring a light jacket or sweater for outdoor events after sunset.",
      },
      language: {
        title: "Language",
        body: "Spanish is the official language of Mexico. English is commonly spoken in hotels, restaurants and tourist areas, but locals always appreciate when visitors try a few Spanish phrases.",
      },
      tips: {
        title: "Local Tips",
        items: [
          "Drink bottled or filtered water rather than tap water.",
          "Tipping is customary in Mexico. A gratuity of 10–15% is standard in restaurants.",
          "Uber is our recommended way to get around Guadalajara.",
          "Electrical outlets are Type A and B (same as US and Canada), 127V.",
          "Most stores and restaurants accept credit cards, but carry some cash for smaller purchases.",
          "Visit our favorite areas: Punto Sao Paulo, Andares, Providencia, Avenida Chapultepec and Tlaquepaque — great restaurants, cafés, shopping and nightlife.",
        ],
      },
      emergency: {
        title: "Emergency Information",
        body: "Emergency Services: 911. If you have any questions during your stay, please feel free to contact us. We will be happy to help!",
      },
      note: {
        title: "A Note from the Bride & Groom",
        body: "For many of you, this will be your first visit to Mexico, and we couldn't be more excited to share our home, culture and traditions with you. We hope you'll take some time to explore Guadalajara, enjoy its incredible food and experience the warmth and hospitality that make this city so special. Thank you for traveling near and far to celebrate with us. Your presence means the world to us, and we can't wait to create unforgettable memories together!",
      },
    },

    footer: {
      message: "With love, Alejandra & Edouard",
      date: "28.NOV.2026",
    },
    admin: {
      title: "Admin Dashboard",
      loginTitle: "Admin access",
      password: "Password",
      login: "Sign in",
      logout: "Sign out",
      stats: {
        total: "Responses",
        attending: "Attending",
        notAttending: "Not attending",
        totalGuests: "Total guests",
      },
      table: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        attending: "Attending",
        guests: "Guests",
        dietary: "Allergies",
        message: "Message",
        date: "Date",
        actions: "Actions",
        delete: "Delete",
        empty: "No RSVPs yet.",
      },
      invalidPassword: "Invalid password",
      tabs: { rsvps: "Responses", guests: "Guest List" },
      guests: {
        search: "Search by name, code or email...",
        filterAll: "All",
        filterPending: "Pending",
        filterConfirmed: "Confirmed",
        filterDeclined: "Declined",
        export: "Export CSV",
        importCsv: "Import CSV",
        addGuest: "Add guest",
        copyLink: "Copy link",
        linkCopied: "Copied!",
        sendWhatsapp: "WhatsApp",
        whatsappMessage: "Hi {name}!\n\nIt's official… we're getting married! 💍\n\nFrom the first memories we created together to all the dreams we now share, every moment has brought us closer to this day. We're so excited to take the next step and begin this beautiful journey together.\n\nWe're delighted to share our wedding website with you, where you'll find all the details of our special day and everything you need to know to celebrate with us:\nhttps://alejandraedouard.com\n\nWhen you're ready, please RSVP before October 12th using your personalized link:\n{link}\n\nWe would be truly honoured to have you with us as we create memories that will stay in our hearts forever!\n\nPlease save both links — you can come back anytime to check details or update your confirmation.\n\nIf you have any questions or need assistance with your RSVP, please feel free to send us a message here.\n\nCan't wait to celebrate with you! 🥂🤍\nAlejandra & Edouard",
        cols: {
          name: "Name",
          code: "Code",
          reserved: "Reserved",
          confirmed: "Confirmed",
          status: "Status",
          email: "Email",
          phone: "WhatsApp / Phone",
          dietary: "Allergies",
          responseDate: "Response date",
          link: "Link",
          actions: "Actions",
        },
        status: { pending: "Pending", confirmed: "Confirmed", declined: "Declined" },
        stats: { totalGuests: "Guests", confirmed: "Confirmed", declined: "Declined", pending: "Pending", reservedSeats: "Reserved seats", confirmedSeats: "Confirmed seats" },
        addModal: {
          title: "Add guest",
          firstName: "First name",
          lastName: "Last name",
          email: "Email",
          phone: "WhatsApp / Phone (with country code)",
          phonePlaceholder: "e.g. +5213312345678",
          code: "Invitation code",
          codeHelp: "e.g. ANA2026 (used in the unique link)",
          seats: "Reserved seats",
          language: "Guest language",
          notes: "Internal notes",
          save: "Save",
          cancel: "Cancel",
        },
        importModal: {
          title: "Import guests from CSV",
          help: "Upload a CSV with columns: first_name, last_name, email, invitation_code, reserved_seats, language, notes. The code must be unique; if you omit it we'll generate one automatically.",
          choose: "Choose file",
          import: "Import",
          imported: "{n} guests imported",
          error: "Error importing file",
          downloadTemplate: "Download CSV template",
        },
        empty: "No guests yet. Add one or import a CSV.",
      },
    },
    guestRsvp: {
      loading: "Loading your invitation...",
      invalidTitle: "Invalid link",
      invalidBody: "We couldn't find your invitation. Please double-check the link or contact the couple.",
      welcome: "Hi, {name}!",
      reservedOne: "We have reserved {n} seat for you.",
      reservedMany: "We have reserved {n} seats for your party.",
      questionAttend: "Will you join us?",
      yes: "Yes, I'll be there",
      no: "Sadly, I can't make it",
      attendingCount: "Number of people attending",
      attendeeNames: "Full name of each attendee",
      attendeeNamePlaceholder: "Attendee {n} name",
      dietary: "Food allergies",
      notes: "Message to the couple",
      notesPlaceholder: "Leave us a few words...",
      submit: "Send response",
      submitting: "Sending...",
      update: "Update response",
      alreadyConfirmed: "You confirmed on {date}. You can update your response if needed.",
      alreadyDeclined: "We received your response on {date}. If anything changes, feel free to update it here.",
      successTitle: "Thank you for confirming!",
      successBody: "Thank you for confirming your attendance. We look forward to celebrating with you.",
      successDeclined: "Thank you for letting us know. We'll miss you so much.",
      maxSeatsHint: "You can only confirm up to {n} people based on your invitation.",
      backHome: "Back to site",
      error: "Something went wrong. Please try again.",
      closedNotice: "The RSVP period closed on October 12, 2026.",
      closedConfirmed: "You confirmed your attendance for {n} guest(s). Thank you!",
      closedDeclined: "We received your response: you won't be able to join us. Thank you for letting us know!",
      closedPending: "We did not receive your RSVP. If you have any questions, please contact the couple directly.",
      expiredTitle: "Thank you from the bottom of our hearts!",
      expiredBody: "Thank you for being part of our story and for all your love. This personalized link is no longer active, but we will always treasure the memories of this special day.",
    },
  },
};
;
;
;
